import { ContentBlock, GuideTypes, Metadata } from "../models";
import { Entry } from "contentful";
import { convertToHtmlString, findContent } from "../utils";
import { FieldMapping, UserContextValues } from "../types";
import { ActivationForm } from "../models";

export const createActivationForm = (
  fieldMapping: FieldMapping<ActivationForm>,
  entries: Entry<ContentBlock & Metadata>[],
  guideType: GuideTypes,
  userContextValues?: UserContextValues,
  ): ActivationForm => {
    const activateOnClick = fieldMapping.activateOnClick as unknown as boolean;
  
    return {
    titleText: convertToHtmlString(
      findContent(entries, fieldMapping.titleText, guideType)?.fields.richContent,
      userContextValues,
    ),
    passcodeHelpHeader: convertToHtmlString(
      findContent(entries, fieldMapping.passcodeHelpHeader, guideType)?.fields.richContent,
      userContextValues,
    ),
    passcodeHelpContent: convertToHtmlString(
        findContent(entries, fieldMapping.passcodeHelpContent, guideType)?.fields.richContent,
        userContextValues,
    ),
    activateOnClick: activateOnClick,
  };
}
